import request from '@/utils/request'
import URL from './urlTranslator'

// 导入模板列表新增
export function saveTemplate(data) {
  return request({
    url: URL.act.reconciliation.saveTemplate,
    method: 'post',
    data
  })
}

// 导入模板列表删除
export function deleteTemplate(data) {
  return request({
    url: URL.act.reconciliation.deleteTemplate,
    method: 'delete',
    data
  })
}

// 导入模板列表编辑
export function updateTemplate(data) {
  return request({
    url: URL.act.reconciliation.updateTemplate,
    method: 'put',
    data
  })
}

// 导入模板列表查询
export function queryTemplateList(data) {
  return request({
    url: URL.act.reconciliation.queryTemplateList,
    method: 'post',
    data
  })
}

// 导入模板窗口新增
export function saveTemplateMapping(data) {
  return request({
    url: URL.act.reconciliation.saveTemplateMapping,
    method: 'post',
    data
  })
}

// 导入模板窗口删除
export function deleteTemplateMapping(data) {
  return request({
    url: URL.act.reconciliation.deleteTemplateMapping,
    method: 'delete',
    data
  })
}

// 导入模板窗口编辑
export function updateTemplateMapping(data) {
  return request({
    url: URL.act.reconciliation.updateTemplateMapping,
    method: 'put',
    data
  })
}

// 导入模板窗口查询
export function queryReconciliationTemplateMappingList(templateName) {
  return request({
    url: URL.act.reconciliation.queryReconciliationTemplateMappingList,
    method: 'get',
    params: { templateName }
  })
}

// 隐藏平台预制模板
export function updateTemplateHideState(params) {
  return request({
    url: URL.act.reconciliation.updateTemplateHideState,
    method: 'put',
    params
  })
}

// 导入模板窗口查询
export function getInitialCheckValue(params) {
  return request({
    url: URL.act.reconciliation.getInitialCheckValue,
    method: 'get',
    params
  })
}
